<template>
  <div class="parent">
    <banner v-bind:bannerObj="bannerObj"></banner>
    <div class="newsWrap">
      <div class="navLeft">
        <ul>
          <li :class="active === 1 ? 'active' : ''" @click="setCurrentState(1)">
            <router-link to="/news">
              <span>全部新闻</span>
              <i>All News</i>
            </router-link>
          </li>
          <li :class="active === 2 ? 'active' : ''" @click="setCurrentState(2)">
            <router-link to="/news/dynamic-news">
              <span>公司动态</span>
              <i>Company dynamics</i>
            </router-link>
          </li>
          <li :class="active === 3 ? 'active' : ''" @click="setCurrentState(3)">
            <router-link to="/news/industry-news">
              <span>行业新闻</span>
              <i>All News</i>
            </router-link>
          </li>
          <li :class="active === 4 ? 'active' : ''" @click="setCurrentState(4)">
            <router-link to="/news/award-news">
              <span>获奖认证</span>
              <i>Award-winning</i>
            </router-link>
          </li>
          <li :class="active === 5 ? 'active' : ''" @click="setCurrentState(5)">
            <router-link to="/news/responsibility-news">
              <span>社会责任</span>
              <i>Social responsibility</i>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="listRightWrap">
        <router-view />
      </div>
    </div>
    <footer>
      <footContent></footContent>
    </footer>
  </div>
</template>

<style lang="scss">
.parent {
  background-color: #fff;
  .newsWrap {
    width: 1200px;
    margin: 80px auto;
    display: flex;
    flex-flow: nowrap row;
    justify-content: space-between;
    align-items: flex-start;
    .navLeft {
      width: 260px;
      ul {
        li {
          &.active {
            background: rgba(230, 230, 230, 1);
            a {
              &:after { background: rgba(255, 203, 51, 1); }
              span { color: rgba(18, 10, 76, 1); }
              i { color: rgba(18, 10, 76, 0.6); }
            }
          }
          padding: 20px;
          border-bottom: 1px solid #ddd;
          background: rgba(250, 250, 250, 1);
          &:last-child {
            border-bottom: none;
          }
          &:hover {
            background: rgba(230, 230, 230, 1);
          }
          a {
            display: block;
            text-indent: 30px;
            font-size: 14px;
            text-align: left;
            position: relative;
            &:after {
              content: "";
              width: 6px;
              height: 6px;
              background: rgba(50, 50, 50, 0.6);
              position: absolute;
              top: 4px;
              left: 10px;
              z-index: 1;
            }
            &:hover:after {
              background: rgba(255, 203, 51, 1);
            }
            &:hover {
              span {
                color: rgba(18, 10, 76, 1);
              }
              i {
                color: rgba(18, 10, 76, 0.6);
              }
            }
            span {
              display: block;
              margin-bottom: 6px;
              font-weight: bold;
              color: rgba(50, 50, 50, 1);
            }
            i {
              display: block;
              color: rgba(50, 50, 50, 0.6);
            }
          }
        }
      }
    }
    .listRightWrap {
      padding-left: 30px;
      flex: 1;
    }

  }
}
</style>
<script>
import store from "../vuex";
import DetailBanner from "../components/DetailBanner";
import FootContent from "../components/FootContent.vue";

export default {
  data() {
    return {
      active: 1,
      bannerObj: {
        imgUrl: require("../assets/images/news.png"),
        text: "NEWS"
      }
    };
  },
  methods: {
      setCurrentState(value) {
          this.active = value;
      }
  },
  components: {
    banner: DetailBanner,
    footContent: FootContent
  },
  store
};
</script>

